<template>
    <div>
        <form @submit.prevent="search()">
            <b-form-group :label="$t('findProduct')" label-class="p-0" class="width-max-400 mb-2">
                <b-input-group class="position-relative">
                    <b-form-input v-model="text" class="z-index-1" :placeholder="$t('nameEanNumberOrModel')" :disabled="requestProductsTreeSearch.getLoading() || rootLoading" />
                    <b-input-group-append class="position-relative ml-0">
                        <ButtonIcon
                            icon="x"
                            size="sm"
                            variant="outline-light"
                            class="border-0 bg-white p-0 my-auto position-absolute z-index-2"
                            style="transform:translate(-50%,-50%); top:50%; left:-15px;"
                            :disabled="requestProductsTreeSearch.getLoading() || rootLoading"
                            @click="reset()"
                        />
                        <ButtonIcon icon="search" :loading="requestProductsTreeSearch.getLoading()" :disabled="rootLoading" @click="search()" />
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </form>
        <Tree
            ref="Tree"
            :options="tree"
            :load-options="loadOptions"
            :normalizer="normalizer"
            selectable
            v-on="$listeners"
            @rootLoading="rootLoading = $event"
        />
    </div>
</template>



<script>
    import Tree from '@/components/common/Tree.vue';

    export default {
        name: 'ProductsTree',
        components: {
            Tree,
        },
        data() {
            return {
                requestProductsTree: this.$req('space/ProductsTree'),
                requestProductsTreeSearch: this.$req('space/ProductsTreeSearch'),
                text: '',
                tree: null,
                rootLoading: false,
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            loading() {
                return false;
            },
        },
        methods: {
            fetchProductsTree(categoryId) {
                return this.requestProductsTree.get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            loadOptions({ parentNode }) {
                return this.fetchProductsTree(parentNode?.entityId);
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: false,
                };
            },
            search() {
                if (!this.text) return;
                this.requestProductsTreeSearch.get({ urlParams: { spaceId: this.spaceId }, requestParams: { search: this.text } }).then(data => {
                    this.tree = data;
                });
            },
            reset() {
                const isTree = !!this.tree;
                this.text = '';
                this.tree = null;
                if (isTree) this.$refs.Tree.$refs.FormSelectTree.$refs.TreeSelect.loadRootOptions();
            },
        },
        created() {
            this.fetchProductsTree();
        },
    };
</script>



<style lang="scss" scoped></style>
